import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./ProductRegisterDetail.module.scss";
import { style as buttonStyle } from "components/buttons/AdminCustomButton";
import FlexChild from "layouts/flex/FlexChild";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import InputText from "components/inputs/InputText";
import { Checkbox } from "@mui/material";
import CustomButton from "components/buttons/CustomButton";
import NiceModal from "@ebay/nice-modal-react";
import RadioChildren from "components/manager/views/forms/radio/RadioChildren";
import RadioGroup from "components/manager/views/forms/radio/RadioGroup";
import { requester, adminRequester } from "App";
import clsx from "clsx";
import InputNumber from "components/inputs/InputNumber";
import InputHashTag from "components/inputs/InputHashTag";
import UploadImage from "components/inputs/upload/UploadImage";
import { useTranslation } from "react-i18next";
import {
  CButton,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CSpinner,
} from "@coreui/react";
import { ProductThumbnailType } from "shared/constants/constants";
import ReactDragSort from "react-drag-sort";
import Dummy from "components/Dummy";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import CIcon from "@coreui/icons-react";
import { cilCursorMove, cilX } from "@coreui/icons";
import UploadBiliBiliVideo from "components/inputs/upload/UploadBiliBiliVideo";
import {
  clone,
  getCurrentLanguageCode,
  validateInput,
  validateInputs,
} from "shared/utils/Utils";
import AdminQuillEditor from "components/inputs/richEditor/AdminQuillEditor";
import { toast, ToastContainer } from "react-toastify";
import { textFormat } from "InitialData/regExp";
import AdminInputImage from "components/inputs/image/AdminInputImage";
import Container from "layouts/container/Container";
import CheckBox from "components/inputs/checkBox/CheckBox";
import FlexGrid from "layouts/flex/FlexGrid";
import AdminImageBlock from "components/inputs/image/AdminImageBlock";
import { useNavigate } from "react-router-dom";
import AdminCustomButton from "components/buttons/AdminCustomButton";
function ProductRegisterDetail() {
  const { t } = useTranslation();
  const inputs = useRef([]);
  const [displayYn, setDisplayYn] = useState(true);
  const [saleYn, setSaleYn] = useState(true);
  const [limitNum, setLimitNum] = useState(0);
  const [pointNum, setPointNum] = useState(0);
  const [taxNum, setTaxNum] = useState(0);
  const [stores, setStores] = useState([]);
  const [store, setStore] = useState();
  const [regions, setRegions] = useState([]);
  const [region, setRegion] = useState();
  const [categories, setCategories] = useState([]);
  const [isMounted, setMounted] = useState(false);
  const [thumbnails, setThumbnails] = useState([]);
  const [options, setOptions] = useState([]);
  const [optionValues, setOptionValues] = useState([]);
  const thumbnailRefs = useRef([]);
  const [product, setProduct] = useState();
  const [isOpenCustomerPrice, setOpenCustomerPrice] = useState(false);
  const [selected, setSelect] = useState([]);
  const [isSpin, setSpin] = useState(false);
  const navigate = useNavigate();
  const onStoreRegisterClick = () => {
    NiceModal.show("storeRegister", {
      onChange: (value) => setStore(value),
    });
  };
  const onCategoryRegisterClick = () => {
    NiceModal.show("categoryRegister", {
      onChange: categoryRegCallback,
    });
  };
  const onOptionRegisterClick = () => {
    NiceModal.show("optionRegister", {
      onChange: optionRegCallback,
      options:
        options.length === 0
          ? [{ title: null, price: 0, qauntity: 0, check: 0, sold: false }]
          : options,
      optionValues: optionValues,
      region: region,
    });
  };
  const optionRegCallback = (options, optionValues) => {
    setOptions(options);
    setOptionValues(optionValues);
  };
  const categoryRegCallback = ({ value }) => {
    setCategories([...new Set([...categories, value])]);
  };

  const onAddThumbnailClick = () => {
    let index = thumbnails.length;
    let thumbnail = {
      index: index,
      id: null,
      type: ProductThumbnailType.IMAGE,
      productId: null,
      content: null,
      value: index,
      key: index,
    };

    setThumbnails((before) => {
      // let oldThumbnails = clone(before);
      // let newThumbnails = oldThumbnails.map((thumbnail, index) => {
      //     let thumbnailRefRow = thumbnailRefs.current[index];
      //     let thumbnailRefRowCol = thumbnailRefRow.getRef();
      //     let content = thumbnailRefRowCol.getValue();
      //     thumbnail.content = content;
      //     return thumbnail;
      // });

      // return [...newThumbnails, thumbnail];
      return [...before, thumbnail];
    });
  };
  const onDeleteClick = (idx) => {
    setOptions([...options.filter((opttion, index) => index !== idx)]);
  };
  const onSelectDeleteClick = () => {
    if (selected?.length === 0) setOptions([]);
    else
      setOptions([
        ...options.filter((opttion, index) => !selected.includes(index)),
      ]);
    setSelect([]);
  };
  const onSelectDuplicateClick = () => {
    const copies = options
      .filter((opttion, index) => selected.includes(index))
      .map((option) => {
        const copy = { ...option };
        delete copy.id;
        return copy;
      });
    setOptions([...options, ...copies]);
    setSelect([]);
  };
  const onSaveClick = () => {
    if (optionValues.length === 0 || options.length === 0) {
      toast.error("옵션은 최소 1개가 필요합니다.", {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      let product = {};
      inputs.current[6].isValid().then(() => {
        product.thumbnail = inputs.current[6].getValue();
        product.title = inputs.current[0].getValue();
        product.handle = new Date().getTime() + "_" + product.title;
        product.description = inputs.current[1].getValue();
        product.status = displayYn ? "published" : "rejected";
        product.categories = categories?.map((category) => ({
          id: category.id,
        }));
        product.store_id = store;
        product.price = inputs.current[2].getValue();
        product.customer_price = isOpenCustomerPrice
          ? inputs.current[3].getValue()
          : null;
        product.buyable = saleYn;
        product.currency_code = region?.currency_code || "krw";
        product.tax = taxNum === 1 ? inputs.current[4].getValue() : null;
        inputs.current[7].isValid().then(() => {
          product.content = inputs.current[7].getValue();
          adminRequester.postProduct({ ...product }, (result) => {
            const { product } = result;

            Promise.all(
              optionValues.map((ov) => {
                return adminRequester.postProductOption(
                  product?.id,
                  { title: ov },
                  () => {}
                );
              })
            ).then(() => {
              adminRequester.getProduct(
                product?.id,
                { expand: "options" },
                (result) => {
                  const { product } = result;
                  Promise.all(
                    options.map((option) => {
                      return option.input.isValid().then(() => {
                        const data = {};

                        data.thumbnail = option.input.getValue();
                        data.title = option.title;
                        data.inventory_quantity = option.quantity;
                        data.check = option.check;
                        data.sold = option.sold;
                        const prices = [
                          {
                            amount:
                              Number(product?.price || 0) +
                              Number(option?.price || 0),
                            currency_code: region?.currency_code || "krw",
                          },
                        ];
                        data.options = product.options.map((op) => ({
                          option_id: op.id,
                          value: option[op.title],
                        }));

                        return adminRequester.postVariants(
                          product?.id,
                          data,
                          async (result) =>
                            await adminRequester.updateVariant(
                              product?.id,
                              result.variant.id,
                              { prices: prices }
                            )
                        );
                      });
                    })
                  ).then(() => {
                    navigate("/admin/productStatus/:id");
                  });
                }
              );
            });
          });
        });
      });
      setSpin(true);
    }
  };

  useEffect(() => {
    if (isMounted) {
      adminRequester.getCurrentUser((result) => setStore(result.user.store_id));
      adminRequester.getStores({}, (result) => setStores(result.stores));
      adminRequester.getRegions((result) => {
        const regions = result.regions;
        setRegions(regions);
        if (regions?.length > 0) setRegion(regions[0]);
      });
    }
  }, [isMounted]);

  useEffect(() => {
    setMounted(true);
  }, []);
  const getName = (category) => {
    return category.parent_category != null
      ? `${getName(category.parent_category)} > ${category.name}`
      : category.name;
  };
  const Button = ({ text, onClick }) => {
    const btnStyle = {
      backgroundColor: "white",
      color: "#727272",
      borderColor: "#727272",
      borderRadius: "5px",
      padding: "3px 10px",
      fontSize: "10pt",
    };
    return (
      <CButton
        style={btnStyle}
        color={"primary"}
        onClick={onClick}
        active={true}
      >
        {text}
      </CButton>
    );
  };

  return (
    <Container maxWidth={1500}>
      <VerticalFlex gap={20}>
        <FlexChild>
          <div className={style.container}>
            <VerticalFlex>
              <FlexChild>
                <div className={style.label}>
                  <Center width={"100%"} textAlign={"left"}>
                    <P>STEP 1. 상품정보입력 </P>
                  </Center>
                </div>
              </FlexChild>
              <FlexChild>
                <div className={style.contentWrap}>
                  <VerticalFlex gap={20}>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>스토어 설정</P>
                        </FlexChild>
                        <FlexChild>
                          <select
                            value={store}
                            onChange={(e) => {
                              setStore(e.target.value);
                            }}
                          >
                            {stores.map((store) => (
                              <option key={store.id} value={store.id}>
                                {store.name}
                              </option>
                            ))}
                          </select>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>지역 설정</P>
                        </FlexChild>
                        <FlexChild>
                          <select
                            value={region?.id}
                            onChange={(e) => {
                              setRegion(
                                regions.find((r) => r.id === e.target.value)
                              );
                            }}
                          >
                            {regions.map((region) => (
                              <option key={region.id} value={region.id}>
                                {region.name}
                              </option>
                            ))}
                          </select>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>카테고리 설정</P>
                        </FlexChild>
                        <FlexChild>
                          <div
                            style={{
                              display: "flex",
                              gap: "15px",
                              flexWrap: "wrap",
                            }}
                          >
                            {categories?.length === 0 && (
                              <P>선택된 카테고리가 없습니다.</P>
                            )}
                            {categories &&
                              categories?.map((category, index) => (
                                <FlexChild key={index} width={"initial"}>
                                  <div
                                    className={style.categoryWrap}
                                    onClick={() =>
                                      setCategories([
                                        ...categories?.filter(
                                          (filter) => filter.id !== category.id
                                        ),
                                      ])
                                    }
                                  >
                                    <Center width={"100%"} textAlign={"left"}>
                                      <P>{getName(category)}</P>
                                    </Center>
                                  </div>
                                </FlexChild>
                              ))}
                          </div>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"} />
                        <FlexChild>
                          {/* <div
                            className={style.categoryModalBtn}
                            onClick={onCategoryRegisterClick}
                          >
                            <P>카테고리 설정</P>
                          </div> */}
                          <AdminCustomButton
                            onClick={onCategoryRegisterClick}
                            style={buttonStyle.white_border}
                            text={"카테고리 설정"}
                          />
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <div className={style.line} />
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>상품명</P>
                        </FlexChild>
                        <FlexChild>
                          <InputText
                            ref={(el) => (inputs.current[0] = el)}
                            name={"상품명"}
                            placeHolder={"상품명을 입력하세요."}
                            regExp={[textFormat]}
                          />
                        </FlexChild>
                        {/* <FlexChild width={"30%"}>
                          <InputText
                            placeHolder={"상품번호 자동 생성"}
                            disabled
                          />
                        </FlexChild> */}
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>요약설명</P>
                        </FlexChild>
                        <FlexChild>
                          <InputText
                            placeHolder={"상품명 밑에 보여지는 문구 입니다."}
                            ref={(el) => (inputs.current[1] = el)}
                            name={"요약설명"}
                          />
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40} justifyContent={"flex-start"}>
                        <FlexChild width={"15%"}>
                          <P>판매가</P>
                        </FlexChild>
                        <FlexChild width={200}>
                          <InputNumber
                            ref={(el) => (inputs.current[2] = el)}
                            name={"판매가"}
                            min={0}
                            max={999999}
                            required={true}
                            width={200}
                            height={50}
                            hideArrow
                            suffix={t(region?.currency_code)}
                          />
                        </FlexChild>
                        {/* <FlexChild width={200}>
                          <input
                            type="checkbox"
                            style={{ display: "block", margin: 5 }}
                            onChange={(e) =>
                              setOpenCustomerPrice(e.target.checked)
                            }
                          />
                          <P>소비자가 설정</P>
                        </FlexChild>
                        <FlexChild width={200}>
                          <InputNumber
                            ref={(el) => (inputs.current[3] = el)}
                            name={"소비자가"}
                            min={0}
                            max={999999}
                            width={200}
                            height={50}
                            disabled={!isOpenCustomerPrice}
                          />
                        </FlexChild> */}
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <div className={style.line} />
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>표시상태</P>
                        </FlexChild>
                        <HorizontalFlex gap={80}>
                          <FlexChild>
                            <FlexChild width={"40%"}>
                              <P>진열상태</P>
                            </FlexChild>
                            {/* <div className={style.radioWrap}> */}
                            <RadioGroup
                              name="display"
                              value={displayYn}
                              onChange={setDisplayYn}
                            >
                              <RadioChildren value={true}>
                                <P>진열</P>
                              </RadioChildren>
                              <RadioChildren value={false}>
                                <P>미진열</P>
                              </RadioChildren>
                            </RadioGroup>
                            {/* </div> */}
                          </FlexChild>
                          <FlexChild>
                            <FlexChild width={"40%"}>
                              <P>판매상태</P>
                            </FlexChild>
                            {/* <div className={style.radioWrap}> */}
                            <RadioGroup
                              name="sales"
                              value={saleYn}
                              onChange={setSaleYn}
                            >
                              <RadioChildren value={true}>
                                <P>판매</P>
                              </RadioChildren>
                              <RadioChildren value={false}>
                                <P>미판매</P>
                              </RadioChildren>
                            </RadioGroup>
                            {/* </div> */}
                          </FlexChild>
                        </HorizontalFlex>
                      </HorizontalFlex>
                    </FlexChild>
                    {/* <FlexChild>
                      <HorizontalFlex gap={40} justifyContent={"flex-start"}>
                        <FlexChild width={"15%"}>
                          <P>구매제한</P>
                        </FlexChild>
                        <RadioGroup
                          name="limit"
                          value={limitNum}
                          onChange={setLimitNum}
                        >
                          <RadioChildren value={0}>기본 설정</RadioChildren>
                          <RadioChildren value={1}>모두구매</RadioChildren>
                          <RadioChildren value={2}>회원만 구매</RadioChildren>
                        </RadioGroup>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40} justifyContent={"flex-start"}>
                        <FlexChild width={"15%"}>
                          <P>적립금</P>
                        </FlexChild>
                        <RadioGroup
                          name="point"
                          value={pointNum}
                          onChange={setPointNum}
                        >
                          <RadioChildren value={0}>기본 설정</RadioChildren>
                          <RadioChildren value={1}>개별 설정</RadioChildren>
                        </RadioGroup>
                      </HorizontalFlex>
                    </FlexChild> */}
                    <FlexChild>
                      <HorizontalFlex gap={40} justifyContent={"flex-start"}>
                        <FlexChild width={"15%"}>
                          <P>세금설정</P>
                        </FlexChild>
                        <RadioGroup
                          name="tax"
                          value={taxNum}
                          onChange={setTaxNum}
                        >
                          <RadioChildren value={0}>
                            <P>가격에포함</P>
                          </RadioChildren>
                          <RadioChildren value={1}>
                            <P>개별설정</P>
                          </RadioChildren>
                        </RadioGroup>
                        <FlexChild width={200}>
                          <InputNumber
                            ref={(el) => (inputs.current[4] = el)}
                            name={"세금"}
                            disabled={taxNum !== 1}
                            min={0.0}
                            max={100.0}
                            step={0.1}
                            value={10}
                            width={200}
                            height={50}
                          />
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                  </VerticalFlex>
                </div>
              </FlexChild>
            </VerticalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <div className={style.container}>
            <VerticalFlex>
              <FlexChild>
                <div className={style.label}>
                  <Center width={"100%"} textAlign={"left"}>
                    <P>STEP 2. 옵션설정 </P>
                  </Center>
                </div>
              </FlexChild>
              <FlexChild>
                <div className={style.contentWrap}>
                  <VerticalFlex gap={20}>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild justifyContent="flex-start">
                          <div
                            className={style.categoryModalBtn}
                            onClick={onOptionRegisterClick}
                          >
                            <P>옵션 설정</P>
                          </div>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <FlexGrid columns={2}>
                        {options.length === 0 ? (
                          <div>생성된 옵션이 없습니다.</div>
                        ) : (
                          <></>
                        )}
                        {options?.map((option, index) => (
                          <VerticalFlex key={option.title + "_" + index}>
                            <HorizontalFlex>
                              <FlexChild width="50px">
                                <input
                                  type="checkbox"
                                  style={{ display: "block", margin: 5 }}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelect([...selected, index]);
                                    } else {
                                      setSelect([
                                        ...selected.filter(
                                          (idx) => index !== idx
                                        ),
                                      ]);
                                    }
                                  }}
                                  checked={selected.includes(index)}
                                />
                              </FlexChild>
                              <HorizontalFlex>
                                <FlexChild>
                                  <P>{option.title}</P>
                                </FlexChild>
                                <FlexChild>
                                  <button onClick={() => onDeleteClick(index)}>
                                    X
                                  </button>
                                </FlexChild>
                              </HorizontalFlex>
                            </HorizontalFlex>
                            <FlexChild flexStart>
                              <FlexChild>
                                {optionValues
                                  ?.map((value) => option[value])
                                  .join(",")}
                              </FlexChild>
                            </FlexChild>
                            <FlexChild>
                              <AdminImageBlock
                                ref={(el) => (option.input = el)}
                                name={"상품 라벨"}
                                path={"/product"}
                                labelWidth={0}
                                cropWidth={600}
                                cropHeight={600}
                                value={
                                  product && product.thumbnail
                                    ? product.thumbnail
                                    : ""
                                }
                                maxSizeMb={1}
                              />
                            </FlexChild>
                          </VerticalFlex>
                        ))}
                      </FlexGrid>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild gap={40} justifyContent="center">
                          <div
                            className={style.categoryModalBtn}
                            onClick={onSelectDeleteClick}
                          >
                            <P>
                              {selected?.length === 0 ? "일괄삭제" : "선택삭제"}
                            </P>
                          </div>
                          <div
                            className={style.categoryModalBtn}
                            onClick={onSelectDuplicateClick}
                          >
                            <P>옵션복사</P>
                          </div>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                  </VerticalFlex>
                </div>
              </FlexChild>
            </VerticalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <div className={style.container}>
            <VerticalFlex>
              <FlexChild>
                <div className={style.label}>
                  <Center width={"100%"} textAlign={"left"}>
                    <P>STEP 3. 상품 상세등록 </P>
                  </Center>
                </div>
              </FlexChild>
              <FlexChild>
                <div className={style.contentWrap}>
                  <VerticalFlex gap={20}>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>썸네일</P>
                        </FlexChild>
                        <FlexChild>
                          <VerticalFlex gap={10} flexStart>
                            <FlexChild>
                              <AdminInputImage
                                ref={(el) => (inputs.current[6] = el)}
                                name={"상품 라벨"}
                                path={"/product"}
                                labelWidth={0}
                                cropWidth={600}
                                cropHeight={600}
                                value={
                                  product && product.thumbnail
                                    ? product.thumbnail
                                    : ""
                                }
                                maxSizeMb={1}
                              />
                            </FlexChild>
                            <FlexChild borderBottom={"2px solid #e7e7e7"}>
                              <Dummy height={10} />
                            </FlexChild>
                          </VerticalFlex>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <div className={style.line} />
                    </FlexChild>
                    <FlexChild height={"100%"}>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>상세페이지</P>
                        </FlexChild>
                        <FlexChild height={"100%"}>
                          <div style={{ maxWidth: "1200px" }}>
                            <AdminQuillEditor
                              ref={(el) => (inputs.current[7] = el)}
                              name={"상세"}
                              value={
                                product && product.content
                                  ? product.content
                                  : ""
                              }
                              path={"product/" + "product.id"}
                              preview={true}
                            />
                          </div>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                  </VerticalFlex>
                </div>
              </FlexChild>
            </VerticalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          {isSpin && <CSpinner style={{ position: "absolute" }} />}
          <Button text={"저장"} onClick={onSaveClick} />
        </FlexChild>
      </VerticalFlex>
    </Container>
  );
}

export default ProductRegisterDetail;
